import ClientService from '../../../services/client-service';
import getDealParticipantListDataQuery from '../../../graphql/query/get-deal-participant-list-data.graphql';
import saveDealParticipantMutation from '../../../graphql/mutation/save-deal-participant.graphql';
import saveDealParticipantListMutation from '../../../graphql/mutation/save-deal-participant-list.graphql';
import saveDealParticipantCommentMutation from '../../../graphql/mutation/save-deal-participant-comment.graphql';
import deleteDealParticipantListMutation from '../../../graphql/mutation/delete-deal-participant-list.graphql';
import deleteDealParticipantCommentMutation from '../../../graphql/mutation/delete-deal-participant-comment.graphql';

export default class DealParticipantsApi {
  public static getDealParticipantListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getDealParticipantListDataQuery, payload);
  }

  public static saveDealParticipant(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealParticipantMutation, payload);
  }

  public static saveDealParticipantList(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealParticipantListMutation, payload);
  }

  public static saveDealParticipantComment(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealParticipantCommentMutation, payload);
  }

  public static deleteDealParticipantList(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteDealParticipantListMutation, payload);
  }

  public static deleteDealParticipantComment(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteDealParticipantCommentMutation, payload);
  }
}
